import {
    ROLE_ADMIN,
    ROLE_ANALYST_ADMIN
} from "src/components/constants";

import {
    ROUTE_PATH_ADMIN_DASHBOARD,
    ROUTE_PATH_ADMIN_KANBAN_BOARD,
    ROUTE_PATH_ADMIN_HOME,
    ROUTE_PATH_ADMIN_OWN_COMPANY_THIRD_PARTIES,
    ROUTE_PATH_ADMIN_SETTINGS,
    ROUTE_PATH_ADMIN_CUSTOMIZATION,
    ROUTE_PATH_ADMIN_USER_LIST,
    ROUTE_PATH_ADMIN_DOCUMENTS,
    ROUTE_PATH_ADMIN_VIEW_DOCUMENTS,
    ROUTE_PATH_ADMIN_QUESTIONNAIRES,
    ROUTE_PATH_ADMIN_HISTORY_LOGS,
    ROUTE_PATH_ADMIN_KEYWORD_MANAGEMENT,
    ROUTE_PATH_ADMIN_LIST_PRODUCTS,
    ROUTE_PATH_ADMIN_LICENSE_MANAGEMENT,
    ROUTE_PATH_ADMIN_COMPLIANCE_MONITORING_DASHBOARD,
    ROUTE_PATH_ADMIN_COMPLIANCE_SCREENING_DASHBOARD,
} from "src/modules/3rd-party-management/constants"

import {
    ROUTE_PATH_ADMIN_E_LEARNING,
    ROUTE_PATH_ADMIN_TUTORIAL,
    ROUTE_PATH_ADMIN_RISK_MANAGMENT,
    ROUTE_PATH_ADMIN_ENTITY_MANAGMENT,
    ROUTE_PATH_ADMIN_PLATFORM_UPDATE
} from "src/common/constants";

import { RiRadarLine, RiShieldCheckLine } from "react-icons/ri";

const AdminMenuItems = [
    {
        titleKey: "Dashboard",
        path: ROUTE_PATH_ADMIN_DASHBOARD,
        icon: "ri-dashboard-line",
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    {
        titleKey: "Kanban Board",
        path: ROUTE_PATH_ADMIN_KANBAN_BOARD,
        icon: "ri-artboard-2-line",
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    {
        titleKey: "Third Party Management",
        path: ROUTE_PATH_ADMIN_HOME,
        icon: "ri-team-line",
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    {
        titleKey: "Own Company",
        path: ROUTE_PATH_ADMIN_OWN_COMPANY_THIRD_PARTIES,
        icon: "ri-building-4-line",
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [
            'entity_management'
        ],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    {
        titleKey: "Compliance Monitoring",
        path: ROUTE_PATH_ADMIN_COMPLIANCE_MONITORING_DASHBOARD,
        icon: () => <RiRadarLine style={{ color: 'var(--theme-primary-text)' }} size="17" className="me-2" />,
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [
            'compliance_monitoring_activation'
        ],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    {
        titleKey: "Compliance Screening",
        path: ROUTE_PATH_ADMIN_COMPLIANCE_SCREENING_DASHBOARD,
        icon: () => <RiShieldCheckLine style={{ color: 'var(--theme-primary-text)' }} size="17" className="me-2" />,
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [
            'compliance_screening_activation'
        ],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    {
        titleKey: "Products",
        path: ROUTE_PATH_ADMIN_LIST_PRODUCTS,
        icon: "ri-archive-drawer-line",
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    {
        titleKey: "Risk Management",
        path: ROUTE_PATH_ADMIN_RISK_MANAGMENT,
        icon: "ri-alert-line",
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    {
        titleKey: "Administration",
        path: null,
        icon: "ri-admin-line",
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [],
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null,
        items: [
            {
                titleKey: "Settings",
                path: ROUTE_PATH_ADMIN_SETTINGS,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [],
                roles: [],
                customValidator: null
            },
            {
                titleKey: "Customisation",
                path: ROUTE_PATH_ADMIN_CUSTOMIZATION,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [],
                roles: [],
                customValidator: null
            },
            {
                titleKey: "Credit Management",
                path: ROUTE_PATH_ADMIN_LICENSE_MANAGEMENT,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [
                    'eudr_activation'
                ],
                roles: [],
                customValidator: null
            },
            {
                titleKey: "Entity Management",
                path: ROUTE_PATH_ADMIN_ENTITY_MANAGMENT,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [
                    'entity_management'
                ],
                roles: [
                    ROLE_ANALYST_ADMIN
                ],
                customValidator: null
            },
            {
                titleKey: "History Logs",
                path: ROUTE_PATH_ADMIN_HISTORY_LOGS,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [
                    "history-logs"
                ],
                roles: [],
                customValidator: null
            },
            {
                titleKey: "Documents",
                path: ROUTE_PATH_ADMIN_DOCUMENTS,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [],
                roles: [],
                customValidator: null
            },
            {
                titleKey: "User Management",
                path: ROUTE_PATH_ADMIN_USER_LIST,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [],
                roles: [],
                customValidator: null
            },
            {
                titleKey: "Keyword Management",
                path: ROUTE_PATH_ADMIN_KEYWORD_MANAGEMENT,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [],
                roles: [
                    ROLE_ANALYST_ADMIN
                ],
                customValidator: null
            },
            {
                titleKey: "Questionnaire Designer",
                path: ROUTE_PATH_ADMIN_QUESTIONNAIRES,
                linkType: "react-router",
                authProtected: true,
                settingKey: null,
                moduleFeatures: [],
                roles: [],
                customValidator: null
            }
        ]
    },
    {
        titleKey: "What’s New",
        path: ROUTE_PATH_ADMIN_PLATFORM_UPDATE,
        icon: "ri-newspaper-line",
        linkType: "react-router",
        moduleFeatures: [],
        authProtected: true,
        settingKey: null,
        roles: [
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    },
    // {
    //     titleKey    :   "E-Learning",
    //     path        :   ROUTE_PATH_ADMIN_E_LEARNING,
    //     icon        :   "ri-video-line",
    //     linkType    :   "react-router",
    //     authProtected   :   true,
    //     settingKey      :   "isElearning",
    //     moduleFeatures  :   [],
    //     roles           :   [],
    //     customValidator :   null
    // },
    {
        titleKey: "Tutorial",
        path: ROUTE_PATH_ADMIN_TUTORIAL,
        icon: "ri-video-line",
        linkType: "react-router",
        authProtected: true,
        settingKey: null,
        moduleFeatures: [],
        roles: [
            ROLE_ADMIN,
            ROLE_ANALYST_ADMIN
        ],
        customValidator: null
    }
];

export default AdminMenuItems;